var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaflet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 198,
    viewBox: "0 0 326 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.3327 84.1995C94.3007 86.3836 131.694 98.3233 144.562 112.884C157.582 127.445 163.183 140.404 161.367 152.926C159.55 165.448 151.526 165.157 148.196 169.816C144.714 174.33 139.869 180.008 130.786 179.426C118.675 178.698 106.261 172.874 97.3286 152.78C88.3966 132.686 89.0021 113.758 89.7591 103.274C90.3646 92.6446 92.3327 84.1995 92.3327 84.1995Z",
    fill: "url(#paint0_linear_38_174)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3921 87.5481L149.406 167.923L146.833 170.689L93.3921 87.5481Z",
    fill: "url(#paint1_linear_38_174)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.698 189.43L32.9814 185.974C42.3327 178.343 53.8565 175.463 63.3023 168.12C66.1361 169.992 67.364 167.256 70.3867 167.544C71.5202 168.984 68.9698 170.999 71.9925 170.711C78.699 172.007 85.311 170.136 91.9231 169.272C98.9129 168.408 105.808 169.416 112.704 168.696C114.876 168.552 118.277 163.944 120.922 166.248C122.15 169.56 116.954 169.848 118.371 173.591C132.068 178.487 166.356 199.221 172.212 176.615C172.307 178.055 171.173 180.646 172.779 180.358C184.303 172.439 203.95 155.449 207.445 150.985C211.223 146.09 216.324 146.234 221.236 144.506C230.209 141.338 239.75 138.171 247.495 131.26C252.312 136.299 262.325 138.891 267.615 137.019C273.188 135.147 281.878 121.037 286.506 115.997C288.301 113.981 291.04 110.238 292.929 112.397C291.607 113.837 293.118 117.869 291.512 117.149C290.662 114.701 288.962 117.581 287.734 117.005C283.106 122.908 278.194 128.38 273.471 133.995C271.204 136.011 275.644 138.171 272.999 138.891C260.719 142.634 241.922 133.275 234.177 146.234C221.897 152.713 210.279 154.297 198.188 164.232C191.198 169.992 182.697 180.358 175.424 185.83C174.196 186.694 172.401 187.126 170.984 188.422C169.19 190.005 168.812 192.165 167.3 192.597C163.617 193.749 155.965 190.869 151.054 189.862C134.996 186.262 117.805 176.327 102.597 175.031C96.5515 174.599 89.4671 176.039 82.6662 176.471C68.2141 177.479 59.2407 178.055 47.6223 183.958C43.0884 186.406 35.7206 192.885 32.698 189.43Z",
    fill: "#3D3D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.456 5.13525C233.882 9.21223 174.537 38.6247 156.825 66.1443C138.961 93.8095 133.965 115.505 140.475 135.89C146.984 156.275 159.247 155.401 166.211 162.099C173.175 168.797 182.713 176.951 198.003 173.747C217.986 169.379 237.213 156.566 246.75 120.747C256.288 84.9275 250.081 53.4766 245.994 36.1494C241.906 18.8222 236.456 5.13525 236.456 5.13525Z",
    fill: "url(#paint2_linear_38_174)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M235.396 11.2505L163.485 159.478L167.724 163.555L235.396 11.2505Z",
    fill: "url(#paint3_linear_38_174)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_174",
    x1: -361.584,
    y1: 4406.92,
    x2: 7596.31,
    y2: 5158.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AC443"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75B843"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_174",
    x1: -511.641,
    y1: 3707.37,
    x2: 6355.92,
    y2: 4218.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B9744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_174",
    x1: 12512.5,
    y1: 7025.21,
    x2: -557.615,
    y2: 8937.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1DB74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACD259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_174",
    x1: 9445.13,
    y1: 5857.61,
    x2: -1863.22,
    y2: 6670.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACD259"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AC443"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaflet);
export default __webpack_public_path__ + "static/media/Leaflet.ecd321e72523ba4ed5fd0371a500cafb.svg";
export { ForwardRef as ReactComponent };